module.exports = {
  normal: "hsl(280, 3%, 21%)",
  hover: "hsl(280, 1.3%, 30%)",
  press: "hsl(280, 1.3%, 45.7%)",
  disabled: "hsl(280, 1.3%, 40%)",
};